module.exports = __webpack_public_path__ + "static/img/cont48 (4).a8e5ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont48 (4).jpg
// module id = AKzo
// module chunks = 0